// The Prompt Editor on Admin › AI Prompts: one prompt, opened from a row of the
// Modules tab (or Add). The details card sets its module, handle, name and
// summary; below it, the shared workspace edits that prompt's versions.

// REACT IMPORTS
import React, { useEffect, useState } from "react";

// MSAL
import { useMsal } from "@azure/msal-react";

// MUI COMPONENTS
import { Button, CircularProgress } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

// CUSTOM COMPONENTS
import PromptDetails from "./PromptDetails";
import PromptWorkspace from "./PromptWorkspace";

// API, CONSTANTS
import { getAPICall } from "../../config/apiCalls";
import { apiError } from "../ITBudget/itBudgetUtils";

const BASE = "/api/ai-prompts";

const PromptEditor = ({ promptKey, canEdit, handlers, onBack, onCreated }) => {
	const { instance, accounts } = useMsal();
	const [prompt, setPrompt] = useState(null);
	const [modules, setModules] = useState([]);
	const [reloadKey, setReloadKey] = useState(0);
	const [error, setError] = useState("");

	useEffect(() => {
		getAPICall(instance, accounts[0], `${BASE}/modules`)
			.then((res) => setModules(res.data))
			.catch(() => {});
	}, []);

	useEffect(() => {
		setPrompt(null);
		if (!promptKey) return;
		getAPICall(instance, accounts[0], `${BASE}/prompts`)
			.then((res) => {
				const found = res.data.find((p) => p.prompt_key === promptKey);
				if (found) setPrompt(found);
				else setError(`No prompt ${promptKey}`);
			})
			.catch((err) => setError(apiError(err, "Couldn't load the prompt.")));
	}, [promptKey]);

	const endpoints = {
		list: `${BASE}/prompts`,
		listParams: prompt ? { module: prompt.module } : undefined,
		version: (id) => `${BASE}/versions/${id}`,
		createDraft: `${BASE}/versions`,
		draft: (id) => `${BASE}/versions/${id}`,
		activate: (id) => `${BASE}/versions/${id}/activate`,
		test: (id) => `${BASE}/versions/${id}/test`,
		subjects: (p) => (p.test_handler && handlers.includes(p.test_handler) ? `${BASE}/test/${p.test_handler}/subjects` : null),
		models: `${BASE}/models`,
		download: (id) => `${BASE}/versions/${id}/download`,
	};

	const saved = (updated) => {
		if (!promptKey) return onCreated(updated.prompt_key);
		setPrompt(updated);
		setReloadKey((k) => k + 1);
	};

	return (
		<>
			<div>
				<Button startIcon={<ArrowBackIcon />} onClick={onBack}>
					Back to Modules
				</Button>
			</div>
			{error && <div className="itBudgetError">{error}</div>}
			{promptKey && !prompt && !error && (
				<div className="itBudgetEmpty">
					<CircularProgress />
				</div>
			)}
			{(!promptKey || prompt) && <PromptDetails prompt={prompt} canEdit={canEdit} modules={modules} handlers={handlers} onSaved={saved} />}
			{prompt && <PromptWorkspace endpoints={endpoints} canEdit={canEdit} singleKey={prompt.prompt_key} reloadKey={reloadKey} />}
		</>
	);
};

export default PromptEditor;
